"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsComponent = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var fab_button_1 = require("../../components/button/fab.button");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var menu_1 = require("../../components/menu/menu");
var menu_item_1 = require("../../components/menu/menu.item");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var table_1 = require("../../components/table/table");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var userDisplayName_1 = require("../../util/userDisplayName");
var accounts_confirm_invite_1 = require("./accounts.confirm.invite");
var accounts_confirm_remove_1 = require("./accounts.confirm.remove");
var accounts_confirm_revoke_1 = require("./accounts.confirm.revoke");
var accounts_confirm_role_1 = require("./accounts.confirm.role");
var accounts_style_1 = require("./accounts.style");
(0, theme_1.addStyles)(accounts_style_1.Style);
var AccountsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsComponent, _super);
    function AccountsComponent(ctrl) {
        var _this = _super.call(this) || this;
        _this.ctrl = ctrl;
        _this.roleMenu = new menu_1.MenuComponent({
            items: function () { return [
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_ADMIN)),
                    action: function () { return _this.confirmUserRoleChange(core_api_1.IkeUserRole.ROOT); },
                    visible: true,
                    disabled: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.ROOT,
                    selected: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.ROOT
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_USER)),
                    action: function () { return _this.confirmUserRoleChange(core_api_1.IkeUserRole.USER); },
                    visible: true,
                    divider: _this.ctrl.haveExtraRoles(),
                    disabled: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.USER,
                    selected: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.USER
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_VIEWER)),
                    action: function () { return _this.confirmUserRoleChange(core_api_1.IkeUserRole.VIEWER); },
                    visible: _this.ctrl.haveExtraRoles(),
                    disabled: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.VIEWER,
                    selected: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.VIEWER
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_EDITOR)),
                    action: function () { return _this.confirmUserRoleChange(core_api_1.IkeUserRole.EDITOR); },
                    visible: _this.ctrl.haveExtraRoles(),
                    disabled: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.EDITOR,
                    selected: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.EDITOR
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_DOWNLOADER)),
                    action: function () { return _this.confirmUserRoleChange(core_api_1.IkeUserRole.DOWNLOADER); },
                    visible: _this.ctrl.haveExtraRoles(),
                    disabled: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.DOWNLOADER,
                    selected: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.DOWNLOADER
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.ROLE_DATA_ADMIN)),
                    action: function () { return _this.confirmUserRoleChange(core_api_1.IkeUserRole.DATA_ADMIN); },
                    visible: _this.ctrl.haveExtraRoles(),
                    disabled: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.DATA_ADMIN,
                    selected: _this.selectedUser && _this.selectedUser.userLevel === core_api_1.IkeUserRole.DATA_ADMIN
                }
            ]; }
        });
        return _this;
    }
    Object.defineProperty(AccountsComponent.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.container }, [
                this.viewPendingUsers(),
                this.viewUsers(),
                this.viewAddButton()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    AccountsComponent.prototype.setSelectedUser = function (user) {
        this.selectedUser = user;
    };
    AccountsComponent.prototype.confirmUserRoleChange = function (userRole) {
        var confirm = new accounts_confirm_role_1.AccountsConfirmRole(this.ctrl, this.selectedUser, userRole);
        confirm.open();
    };
    AccountsComponent.prototype.viewAddButton = function () {
        var _this = this;
        if (!this.ctrl.isDepartmentAdmin) {
            return null;
        }
        return fab_button_1.FabButton.view({
            title: index_1.T.ACCOUNTS_INVITE_TITLE,
            onclick: function () {
                var requestInviteComponent = new accounts_confirm_invite_1.AccountsInviteComponent(_this.ctrl);
                requestInviteComponent.open();
            }
        });
    };
    AccountsComponent.prototype.viewUsers = function () {
        var headers = ['#', (0, index_1.Translate)(index_1.T.SIGNUP_EMAIL), (0, index_1.Translate)(index_1.T.ACCOUNTS_NAME), (0, index_1.Translate)(index_1.T.ACCOUNTS_ROLE)];
        var rows = [];
        var departmentUsers = this.ctrl.users;
        for (var i = 0; i < departmentUsers.length; i++) {
            var user = departmentUsers[i];
            rows.push(this.viewUser(user, i));
        }
        return table_1.Table.view((0, index_1.Translate)(index_1.T.ACCOUNTS_TITLE), headers, rows);
    };
    AccountsComponent.prototype.viewUser = function (user, index) {
        var displayName = (0, userDisplayName_1.userDisplayName)(user);
        return [
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }, String(index + 1)),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }, user.username),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCellFaint }, displayName !== user.username ? displayName : ''),
            (0, mithril_1.m)('span', {}, this.viewRoleButton(user)),
            this.ctrl.isDepartmentAdmin ? this.viewRoleActions(user) : null
        ];
    };
    AccountsComponent.prototype.viewRole = function (user) {
        var userLevel = this.getUserLevel(user);
        var roleTranslateKey = services_1.Services.UserProfile.isDepartmentAdmin(user) ? index_1.T.ROLE_ADMIN : index_1.T.ROLE_USER;
        if (userLevel) {
            return (0, mithril_1.m)('span', {}, userLevel);
        }
        return (0, mithril_1.m)('span', {}, (0, index_1.Translate)(roleTranslateKey));
    };
    AccountsComponent.prototype.viewRoleButton = function (user) {
        var _this = this;
        if (this.ctrl.isLoadingUser(user)) {
            return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.tableCellRoleActions }, spinner_1.Spinner.view());
        }
        if (user.objectId === services_1.Services.User.current.objectId) {
            return [
                (0, mithril_1.m)('button', {
                    className: "".concat(accounts_style_1.CSS.changeRole, "  mdl-button mdl-js-button mdl-js-ripple-effect"),
                    style: { 'font-size': '13px' },
                    disabled: true
                }, this.viewRole(user))
            ];
        }
        if (!this.ctrl.isDepartmentAdmin) {
            return [
                (0, mithril_1.m)('button', {
                    className: "".concat(accounts_style_1.CSS.changeRole, "  mdl-button mdl-js-button mdl-js-ripple-effect"),
                    style: { 'font-size': '13px', color: '#000000' },
                    disabled: true
                }, this.viewRole(user))
            ];
        }
        return [
            (0, mithril_1.m)('button', {
                className: "".concat(accounts_style_1.CSS.changeRole, "  mdl-button mdl-js-button mdl-js-ripple-effect"),
                style: { 'font-size': '13px' },
                onclick: function () {
                    _this.setSelectedUser(user);
                    _this.roleMenu.show();
                }
            }, this.viewRole(user)),
            this.selectedUser && this.selectedUser.objectId === user.objectId ? this.roleMenu.view() : null
        ];
    };
    AccountsComponent.prototype.getUserLevel = function (user) {
        if (services_1.Services.UserProfile.isDepartmentEditor(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_EDITOR);
        }
        if (services_1.Services.UserProfile.isDepartmentDownloader(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_DOWNLOADER);
        }
        if (services_1.Services.UserProfile.isDepartmentViewer(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_VIEWER);
        }
        if (services_1.Services.UserProfile.isDepartmentDataAdmin(user)) {
            return (0, index_1.Translate)(index_1.T.ROLE_DATA_ADMIN);
        }
        return null;
    };
    AccountsComponent.prototype.viewRoleActions = function (user) {
        if (this.ctrl.isLoadingUser(user)) {
            return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.tableCellRoleActions }, spinner_1.Spinner.view());
        }
        var role = user.role;
        return (0, mithril_1.m)('div', { className: "".concat(accounts_style_1.CSS.tableCellRoleActions, " ").concat(accounts_style_1.CSS.tableCellGhost) }, [
            this.ctrl.canRemove(role) ? this.viewRemoveButton(user) : null
        ]);
    };
    AccountsComponent.prototype.viewPendingUsers = function () {
        var pendingUsers = this.ctrl.pendingUsers;
        if (pendingUsers.length === 0) {
            return null;
        }
        var headers = ['#', (0, index_1.Translate)(index_1.T.SIGNUP_EMAIL), (0, index_1.Translate)(index_1.T.ACCOUNTS_ROLE), (0, index_1.Translate)(index_1.T.ACCOUNTS_INVITE_EXPIRES)];
        var rows = [];
        for (var i = 0; i < pendingUsers.length; i++) {
            rows.push(this.viewPendingUser(pendingUsers[i], i));
        }
        return table_1.Table.view((0, index_1.Translate)(index_1.T.ACCOUNTS_INVITES_PENDING), headers, rows);
    };
    AccountsComponent.prototype.viewPendingUser = function (invite, index) {
        var role = '-';
        if (invite.role) {
            role = invite.role === 'root' ? 'admin' : invite.role;
        }
        return [
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }, String(index + 1)),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }, invite.email),
            (0, mithril_1.m)('span', { className: "".concat(accounts_style_1.CSS.tableCellFaint, " ").concat(accounts_style_1.CSS.tableCellUppercase) }, role),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCellFaint }, services_1.Services.DateTime.formatDateTime(new Date(invite.expiresAt))),
            (0, mithril_1.m)('span', { className: accounts_style_1.CSS.tableCell }),
            this.viewPendingUserRoleActions(invite)
        ];
    };
    AccountsComponent.prototype.viewPendingUserRoleActions = function (invite) {
        if (this.ctrl.isLoadingInvite(invite)) {
            return (0, mithril_1.m)('div', { className: accounts_style_1.CSS.tableCellRoleActions }, spinner_1.Spinner.view());
        }
        return (0, mithril_1.m)('div', { className: "".concat(accounts_style_1.CSS.tableCellRoleActions, " ").concat(accounts_style_1.CSS.tableCellGhost) }, this.viewRevokeInviteButton(invite));
    };
    AccountsComponent.prototype.viewRemoveButton = function (user) {
        var _this = this;
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            title: index_1.T.ACCOUNTS_REMOVE,
            onclick: function () {
                var confirm = new accounts_confirm_remove_1.AccountsConfirmRemove(_this.ctrl, user);
                confirm.open();
            }
        });
    };
    AccountsComponent.prototype.viewRevokeInviteButton = function (invite) {
        var _this = this;
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            title: index_1.T.ACCOUNTS_REVOKE,
            onclick: function () {
                var confirm = new accounts_confirm_revoke_1.AccountsConfirmRevoke(_this.ctrl, invite);
                confirm.open();
            }
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], AccountsComponent.prototype, "selectedUser", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AccountsComponent.prototype, "setSelectedUser", null);
    return AccountsComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.AccountsComponent = AccountsComponent;
//# sourceMappingURL=accounts.js.map